/* eslint-disable eqeqeq */
import React, { useLayoutEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import Modifiers from '@containers/Modifiers';
import SpecialInstruction from './specialInstruction';
import OrderItemDetail from '@components/OrderItemDetail';
import Loader from '@components/common/Loader';
import Modal from '@components/common/Modal';
import cn from 'classnames';
import styles from './orderItem.module.scss';
import {
  pushModifiersGroupData,
  addToCart,
  removeItemFromCart,
  editCartItem,
  pushModifierToItem,
  toggleNestedModifierFlag,
  changeMenu,
  pushMenuItemsByScreenId,
  orderItems,
  onSearchItem,
  addChecks,
  updateCartAfterNote,
  setFunctionModifierId,
  deleteItm,
  enableStartOverBtn
} from '@reducers/orders';
import {
  updateChecksAfterResponse
} from '@reducers/storeChecks';
import { keyboardInput } from '@reducers/keyboard';
import cloneDeep from 'lodash/cloneDeep';
import { updateHeaderData } from '@reducers/header';
import { setNotification } from '@reducers/notification';
import { APP_CONFIG, ERROR_MESSAGE } from '@constants';
import { LABEL } from '../../veriables';
import {
  getObjectValue,
  urlSearchParams,
  mapStringCartToObject,
  renderExcludeModifier
} from '@utility/utills';
import { flowType } from '@utility/userInfo';
import uuidv4 from 'uuid/v4';

const getCartItemNote = (menuItem, cart, internalId) => {
  let note = '';
  const cartItem = _.find(cart, (d) => ((d.menuItemId === menuItem.menuItemId) && (d.menuTypeId === menuItem.menuTypeId) && (d.internalId === Number(internalId))));
  if (cartItem) {
    note = cartItem.note;
  }
  return note;
};

const OrderItem = (props) => {

  // Props Destructuring

  const {menuCard, cart, enableStartOverBtn, setFunctionModifierId, pushModifierToItem, pushModifiersGroupData, modifierData, menuItemsHashTable,
  modifiersHashTable, modifierGroupsHashTable, menusHashTable, menusList, menuIndex, deviceInfo, activeMenuItemId, position, auth, seat, userInfo,
  addChecks, updateChecksAfterResponse, addToCart, setNotification, editCartItem, deleteItm, isNestedModifier, toggleNestedModifierFlag, 
  updateCartAfterNote, modifierLoder, changeMenu,  } = props;

  // State Management

  const isLoaderRequried = true;
  const [isModifierError, setIsModifierError] = useState(false);  
  const [errorMessage, setErrorMessage] = useState('');
  const [disable, setDisable] = useState(false);
  const query = new URLSearchParams(props.location.search);
  const type = query.get('type');
  const refDetails = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [itemInfo, setItemInfo] = useState(menuCard[props.match.params.menuTypeId][props.match.params.menuItemId]);
  const [note, setNote] = useState(getCartItemNote(menuCard[props.match.params.menuTypeId][props.match.params.menuItemId], cart, props.match.params.internalId));
  const [cartQuantity, addCart] = useState(1);
  const [isRemoveCartModelOpen, setRemoveCartModel] = useState(false);
  const [info, setInfo] = useState(false);
  const [selectedModifiers, setSelectedModifiers] = useState(null);
  const parentMenuItemInfo = urlSearchParams('parentMenuItemId') ? menuCard[props.match.params.menuTypeId][Number(urlSearchParams('parentMenuItemId'))] : null;
  const orderType = urlSearchParams('orderType');
  const isOrderAnother = orderType === 'orderAnother';
  const [modifierNote, setModifierNote] = useState({});
  const isKiosk = flowType() === 'kiosk';
  const [isLinkedItemClicked, setLinkedItemClicked] = useState(false);


  // React Hooks

  useLayoutEffect(() => {
    enableStartOverBtn(false);
    setFunctionModifierId(null);
    window.sessionStorage.setItem('payMultiCart', false);
  }, []);

  useLayoutEffect(() => {
    setItemInfo(menuCard[props.match.params.menuTypeId][props.match.params.menuItemId]);
    setNote(getCartItemNote(menuCard[props.match.params.menuTypeId][props.match.params.menuItemId], cart, props.match.params.internalId));
    setRemoveCartModel(false);
  }, [window.location.href]);

  useLayoutEffect(() => {
    pushModifierToItem([]);
    renderInitialData();
    return () => {
      pushModifierToItem([]);
      pushModifiersGroupData([]);
      setItemInfo(null);
    };
  }, [window.location.href]);

  useLayoutEffect(() => {
    const sortedModifierData = _.sortBy(modifierData, (o) => {
      return getObjectValue(() => _.find(menuItemsHashTable[Number(props.match.params.menuItemId)].modifierGroupLinks, (d) => d.modifierGroupId === Number(o.split('|')[0].split('-')[1])).sortOrder, 200);
    });
    const dataToSend = {
      quantity: cartQuantity,
      price: itemInfo.price,
      menuItemId: itemInfo.menuItemId,
      menuTypeId: itemInfo.menuTypeId,
      modifiers: sortedModifierData,
      menuItemName: (itemInfo.menuItem || {}).name,
      favorite: itemInfo.menuItem.favorite,
    };
    let cartItem = updateExcludeModifier([dataToSend]);
    cartItem = applyModFunction(cartItem);
    const modifierObject = getObjectValue(() => mapStringCartToObject(cartItem, [], modifiersHashTable, modifierGroupsHashTable)[0].modifiers, []);
    dataToSend.modifierObject = modifierObject;
    const modiferPrice = calculateModifierAmount(modifierData);
    const requestData = {
      ...dataToSend,
      note,
      pending: true,
      price: Number(dataToSend.price) + modiferPrice,
      menuScreenId: Number(props.match.params.menuTypeId),
      ageRestricted: menusHashTable[Number(props.match.params.menuTypeId)].ageRestricted,
      internalId: new Date().getTime(),
      menuId: menusList[menuIndex].id,
      storeId: deviceInfo.storeId,
      modifiers: dataToSend.modifierObject,
      modifierData: modifierData
    };
    requestData.modifierJson = JSON.stringify(requestData);
    setSelectedModifiers(requestData);
  }, [modifierData, cartQuantity]);

  useLayoutEffect(() => {
    if (itemInfo.quantity) {
      addCart(itemInfo.quantity);
    }
  }, [itemInfo.quantity]);

  // Methods

  const renderInitialData = () => {
    const modifierList = menuItemsHashTable[props.match.params.menuItemId].modifierGroupLinks.map((item) => ({
      ...item,
      ...modifierGroupsHashTable[item.modifierGroupId]
    }));
    pushModifiersGroupData(modifierList);
    if (!props.match.params.internalId) {
      const preSelectModList = [];
      modifierList.forEach((modGroup) => {
        if (modGroup.hiddenMenuId === activeMenuItemId && ((modGroup.hiddenAutoAddModifierId !== null && !modGroup.hiddenMenuId) || (modGroup.hiddenAutoAddMenuItemId !== null && !modGroup.hiddenMenuId))) {
          preSelectModList.push(modGroup.hiddenAutoAddModifierId ? `${modGroup.hiddenAutoAddModifierId}-${modGroup.id}` : `${modGroup.hiddenAutoAddMenuItemId}-${modGroup.id}`);
        } else if (modGroup.hiddenAutoAddMenuItemId) {
          preSelectModList.push(`${modGroup.hiddenAutoAddMenuItemId}-${modGroup.id}`);
        } else if (modGroup.hiddenAutoAddModifierId && modifiersHashTable[modGroup.hiddenAutoAddModifierId]) {
          preSelectModList.push(`${modGroup.hiddenAutoAddModifierId}-${modGroup.id}`);
        } else {
        }
      });
      pushModifierToItem(preSelectModList);
    } else if (props.match.params.internalId !== 'internalId' && props.match.params.internalId !== undefined) {
      const menuItem = _.find(cart, (d) => d.internalId === Number(props.match.params.internalId));
      pushModifierToItem(menuItem && menuItem.modifierData ? menuItem.modifierData : []);
      setItemInfo({ ...itemInfo, quantity: menuItem && menuItem.quantity ? menuItem.quantity : 1 });
    } else {
      const preSelectModList = [];
      modifierList.forEach((modGroup) => {
        if (modGroup.hiddenMenuId === activeMenuItemId && ((modGroup.hiddenAutoAddModifierId !== null && !modGroup.hiddenMenuId) || (modGroup.hiddenAutoAddMenuItemId !== null && !modGroup.hiddenMenuId))) {
          preSelectModList.push(modGroup.hiddenAutoAddModifierId ? `${modGroup.hiddenAutoAddModifierId}-${modGroup.id}` : `${modGroup.hiddenAutoAddMenuItemId}-${modGroup.id}`);
        } else {
        }
      });
      pushModifierToItem(preSelectModList);
    }
  };

  const calculateModifierAmount = (modifierData) => {
    let modiferPrice = 0;
    const modifierObject = mapStringCartToObject([{ modifiers: modifierData }], []);
    const getModifierAmount = (modifierList) => {
      modifierList.forEach((mod) => {
        modiferPrice += (mod.quantity * getObjectValue(() => Number(_.find(modifierGroupsHashTable[mod.modifierGroupId].modifierLinks, (d) => d.modifierId === Number(mod.modifierId)).price), 1));
        if (mod.modifiers) {
          getModifierAmount(mod.modifiers);
        }
      });
    };
    getModifierAmount(modifierObject[0].modifiers);
    return modiferPrice;
  };

  const getModifierWeight = (modifiersList) => {
    let weight = 0;
    (modifiersList || []).forEach((modifier) => {
      if (modifierGroupsHashTable[Number(modifier.split('-')[1])].isWeight) {
        for (let index = 0; index < modifierGroupsHashTable[modifier.split('-')[1]].modifierLinks.length; index += 1) {
          const ele = modifierGroupsHashTable[modifier.split('-')[1]].modifierLinks[index];
          if (ele.modifierId === Number(modifier.split('-')[0])) {
            weight += ele.weight;
            break;
          } else if (index === ele.length - 1) {
            weight += 1;
          }
        }
        if (weight === 0) weight += 1;
        if (modifier.includes('|')) {
          for (let index = 0; index < modifierGroupsHashTable[modifier.split('-')[1]].modifierLinks.length; index += 1) {
            const ele = modifierGroupsHashTable[modifier.split('-')[1]].modifierLinks[index];
            if (ele.modifierId === Number(modifier.split('-')[0])) {
              weight = ele.weight;
            } else if (index === ele.length - 1) {
              weight = 1;
            }
          }
          if (weight === 0) weight += 1;
        }
      } else {
        weight += modifiersHashTable[modifier.split('-')[0]].weight || 1;
        if (modifier.includes('|')) {
          weight = modifiersHashTable[modifier.split('-')[0]].weight || 1;
        }
      }
    });
    return weight;
  };

  const updateExcludeModifier = (cartItemsList) => {
    const cartTemp = cloneDeep(cartItemsList);
    cartTemp.forEach((cartItem) => {
      renderExcludeModifier(menuItemsHashTable[cartItem.menuItemId].modifierGroupLinks, cartItem, modifierGroupsHashTable, modifiersHashTable, '');
      cartItem.modifiers.filter((d) => (d.includes('|') && !d.includes('-0'))).forEach((d) => {
        renderExcludeModifier(modifiersHashTable[d.split('|')[0].split('-')[0]].modifierGroupLinks, cartItem, modifierGroupsHashTable, modifiersHashTable, `${d.split('|')[0]}|`);
      });
    });
    return cartTemp;
  };

  const applyModFunction = (cartItemsList) => {
    cartItemsList.forEach((cartItem) => {
      cartItem.modifiers.forEach((modifier) => {
        modifier.split('|').forEach((mod, i) => {
          if (mod.split('-')[1] && (modifierGroupsHashTable[mod.split('-')[1]] || {}).applyModFunction) {
            if (i === 0 && !cartItem.modifiers.includes(`${mod}|${modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierId}-${modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierGroupId}`)) {
              cartItem.modifiers.push(`${mod}|${modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierId}-${modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierGroupId}`);
            } else if (!cartItem.modifiers.includes(`${modifier}|${modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierId}-${modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierGroupId}`)) {
              cartItem.modifiers.push(`${modifier}|${modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierId}-${modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierGroupId}`);
            }
          }
        });
      });
    });
    return cartItemsList;
  };

  const menuAddToCart = (data, isLinkedItemAdd, isLinkedEdit, parentContainsLinkedItem, linkedItems, step, cart, uniqueIdForLinkedItem) => {
    let dataToSend = data;
    if (linkedItems) {
      const linkedMenuItemInfo = menuItemsHashTable[Number(linkedItems[step].split('|')[0].split('-')[0])];
      const linkedMenuItemModifierData = modifierData.filter((d) => d.includes(Number(linkedItems[step].split('|')[0]) && !modifierGroupsHashTable[Number(linkedItems[step].split('|')[0].split('-')[1])].linked));
      const linkedMenuAddData = {
        quantity: cart,
        price: linkedMenuItemInfo.price || null,
        menuItemId: linkedMenuItemInfo.id,
        menuTypeId: itemInfo.menuTypeId || null,
        modifiers: linkedMenuItemModifierData,
        menuItemName: linkedMenuItemInfo.name,
        favorite: linkedMenuItemInfo.favorite,
        modifierData: linkedMenuItemModifierData,
        isLinked: true,
        uniqueIdForLinkedItem
      };
      dataToSend = linkedMenuAddData;
    }
    let cartItem = updateExcludeModifier([dataToSend]);
    cartItem = applyModFunction(cartItem);
    const modifierObject = getObjectValue(() => mapStringCartToObject(cartItem, [], modifiersHashTable, modifierGroupsHashTable)[0].modifiers, []);
    dataToSend.modifierObject = modifierObject.filter((e) => e.modifierGroupId);
    let modifierCopy;
    if (!isLinkedItemAdd && parentContainsLinkedItem) {
      const sortedModifierDataWithLinkedItems = _.sortBy(modifierData, (o) => {
        return getObjectValue(() => _.find(menuItemsHashTable[Number(props.match.params.menuItemId)].modifierGroupLinks, (d) => d.modifierGroupId === Number(o.split('|')[0].split('-')[1])).sortOrder, 200);
      });
      const dataToSendCopy = data;
      dataToSendCopy.modifiers = sortedModifierDataWithLinkedItems;
      let cartItemCopy = updateExcludeModifier([dataToSendCopy]);
      cartItemCopy = applyModFunction(cartItemCopy);
      const modifierObjectCopy = getObjectValue(() => mapStringCartToObject(cartItemCopy, [], modifiersHashTable, modifierGroupsHashTable)[0].modifiers, []);
      modifierCopy = modifierObjectCopy.filter((e) => e.modifierGroupId);
    }
    if (!props.match.params.internalId || isLinkedEdit) {
      const modiferPrice = calculateModifierAmount(modifierData);
      const requestData = {
        ...dataToSend,
        note,
        pending: true,
        seatIds: position.number === -1 ? [] : [position.seatId],
        price: Number(dataToSend.price) + modiferPrice,
        menuScreenId: Number(props.match.params.menuTypeId),
        ageRestricted: menusHashTable[Number(props.match.params.menuTypeId)].ageRestricted,
        internalId: new Date().getTime(),
        menuId: menusList[menuIndex].id,
        storeId: deviceInfo.storeId,
        modifiers: dataToSend.modifierObject,
        modifierData: modifierData
      };
      const modifierJsonData = {
        ...requestData,
        modifiers: !isLinkedItemAdd && parentContainsLinkedItem ? modifierCopy : requestData.modifiers
      };
      requestData.modifierJson = JSON.stringify(modifierJsonData);
      const dataToSendToAdd = {
        storeId: deviceInfo.storeId,
        employeeId: auth.id,
        deviceId: deviceInfo.deviceId,
        checkHeaderId: seat.id,
        employeeCard: getObjectValue(() => userInfo.employeeCard, null),
        items: [requestData],
        orderJson: JSON.stringify(requestData),
        longitude: '0',
        latitude: '0',
        geoLocation: '0'
      };
      addChecks(dataToSendToAdd, 'add', isLoaderRequried).then((result) => {
        updateChecksAfterResponse(result);
        const responseObj = getObjectValue(() => result.orders[0], []).items[result.orders[0].items.length - 1];
        requestData.modifiers = !isLinkedItemAdd && parentContainsLinkedItem ? modifierCopy : requestData.modifiers;
        const cartData = {
          ...requestData,
          id: responseObj.id,
          checkItemId: responseObj.checkItemId
        };
        addToCart(cartData);
        if (linkedItems && step !== linkedItems.length - 1) {
          menuAddToCart([], true, isLinkedEdit, false, linkedItems, step + 1, cart, uniqueIdForLinkedItem);
        }
      }).catch((err) => {
        setNotification({
          type: 'danger',
          message: err.message
        });
      });
      props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/orders`);
    } else if (props.match.params.internalId && type && type.includes('repeat')) {
      const modiferPrice = calculateModifierAmount(modifierData);
      const requestData = {
        ...dataToSend,
        note,
        pending: true,
        seatIds: position.number === -1 ? [] : [position.seatId],
        price: Number(dataToSend.price) + modiferPrice,
        menuScreenId: Number(props.match.params.menuTypeId),
        ageRestricted: menusHashTable[Number(props.match.params.menuTypeId)].ageRestricted,
        internalId: new Date().getTime(),
        menuId: menusList[menuIndex].id,
        storeId: deviceInfo.storeId,
        modifiers: dataToSend.modifierObject,
        modifierData: modifierData
      };
      requestData.modifierJson = JSON.stringify(requestData);
      const dataToSendToAdd = {
        storeId: deviceInfo.storeId,
        employeeId: auth.id,
        deviceId: deviceInfo.deviceId,
        checkHeaderId: seat.id,
        employeeCard: getObjectValue(() => userInfo.employeeCard, null),
        items: [requestData],
        orderJson: JSON.stringify(requestData),
        longitude: '0',
        latitude: '0',
        geoLocation: '0'
      };
      addChecks(dataToSendToAdd, 'add', isLoaderRequried).then((res) => {
        updateChecksAfterResponse(res);
        const responseObj = getObjectValue(() => res.orders[0], []).items[res.orders[0].items.length - 1];
        requestData.modifiers = !isLinkedItemAdd && parentContainsLinkedItem ? modifierCopy : requestData.modifiers;
        const cartData = {
          ...requestData,
          id: responseObj.id,
          checkItemId: responseObj.checkItemId
        };
        addToCart(cartData);
      }).catch((e) => {
        setNotification({
          type: 'danger',
          message: e.message
        });
      });
      props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/orders`);
    } else {
      const editCheckItemId = Number(urlSearchParams('checkItem'));
      const modiferPrice = calculateModifierAmount(modifierData);
      let seatId = 0;
      if (position.number === -1 || !position.seatId) {
        seatId = [];
      } else {
        seatId = [position.seatId];
      }
      const requestObj = {
        ...dataToSend,
        note,
        pending: true,
        seatIds: Number(urlSearchParams('seatId')) ? [Number(urlSearchParams('seatId'))] : seatId,
        price: Number(dataToSend.price) + modiferPrice,
        internalId: !Number(props.match.params.internalId) ? new Date().getTime() : Number(props.match.params.internalId),
        menuScreenId: Number(props.match.params.menuTypeId),
        ageRestricted: menusHashTable[Number(props.match.params.menuTypeId)].ageRestricted,
        menuId: menusList[menuIndex].id,
        storeId: deviceInfo.storeId,
        modifiers: dataToSend.modifierObject,
        modifierData: modifierData
      };
      const modifierJsonData = {
        ...requestObj,
        modifiers: isLinkedItemAdd && parentContainsLinkedItem ? modifierCopy : requestObj.modifiers
      };
      requestObj.modifierJson = JSON.stringify(modifierJsonData);
      const itemInfoObj = {
        ...requestObj,
        seatIds: position.number === -1 || !position.seatId ? [] : [position.seatId],
        modifiers: dataToSend.modifierObject,
        suppressNote: false,
        openPrice: null,
        ageRestricted: false,
        checkOrderItemId: Number(urlSearchParams('checkItem'))
      };

      const dataToSendToAdd = {
        storeId: deviceInfo.storeId,
        employeeId: auth.id,
        deviceId: deviceInfo.deviceId,
        checkHeaderId: seat.id,
        employeeCard: getObjectValue(() => userInfo.employeeCard, null),
        items: [itemInfoObj],
        orderJson: JSON.stringify(itemInfoObj),
        longitude: '0',
        latitude: '0',
        geoLocation: '0'
      };
      addChecks(dataToSendToAdd, 'update').then((res) => {
        updateChecksAfterResponse(res);
        const responseObj = getObjectValue(() => res.orders[0], []).items.find((si) => si.id === editCheckItemId);
        requestObj.modifiers = !isLinkedItemAdd && parentContainsLinkedItem ? modifierCopy : requestObj.modifiers;
        const cartData = {
          ...requestObj,
          id: responseObj.id,
          checkItemId: responseObj.checkItemId
        };
        editCartItem(cartData);
        props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/orders`);
      }).catch((e) => {
        setNotification({
          type: 'danger',
          message: e.message
        });
      });
    }
  };

  const deleteItem = (data) => {
    const datatosend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      checkHeaderId: seat.id,
      employeeCard: getObjectValue(() => userInfo.employeeCard, null),
      items: data.map((e) => {
        return { checkOrderItemId: e.id };
      })
    };
    deleteItm(datatosend).then((res) => {
      updateChecksAfterResponse(res);
    }).catch((e) => {
      console.log(e);
    });
  };

  const handleLinkedMenuItemAdd = (linkedMenuItems, cart, uniqueIdForLinkedItem, isLinkedEdit) => {
    menuAddToCart([], true, isLinkedEdit, false, linkedMenuItems, 0, cart, uniqueIdForLinkedItem);
  };

  const getLinkedUniqueId = (linkedMenuItems, parentMenuItemIndex) => {
    let uniqueId = null;
    if (linkedMenuItems.length > 0 && props.match.params.internalId) {
      uniqueId = cart[parentMenuItemIndex].uniqueIdForLinkedItem;
    } else if (linkedMenuItems.length > 0) {
      uniqueId = uuidv4();
    }
    return uniqueId;
  };

  const handleonAddToCart = (cart) => {
    let sortedModifierData = _.sortBy(modifierData, (o) => {
      return getObjectValue(() => _.find(menuItemsHashTable[Number(props.match.params.menuItemId)].modifierGroupLinks, (d) => d.modifierGroupId === Number(o.split('|')[0].split('-')[1])).sortOrder, 200);
    });
    const linkedMenuItems = sortedModifierData.filter((d) => d && modifierGroupsHashTable[Number(d.split('|')[0].split('-')[1])].linked && !d.split('|')[1]);
    if (linkedMenuItems.length > 0) {
      sortedModifierData = sortedModifierData.filter((d) => d && !modifierGroupsHashTable[Number(d.split('|')[0].split('-')[1])].linked);
    }
    const parentMenuItemIndex = cart.findIndex((c) => c.menuItemId === itemInfo.menuItemId);
    const uniqueIdForLinkedItem = getLinkedUniqueId(linkedMenuItems, parentMenuItemIndex);
    const parentContainsLinkedItem = linkedMenuItems.length > 0;
    const dataToSend = {
      quantity: cart,
      price: itemInfo.price,
      menuItemId: itemInfo.menuItemId,
      menuTypeId: itemInfo.menuTypeId,
      modifiers: sortedModifierData,
      menuItemName: (itemInfo.menuItem || {}).name,
      favorite: itemInfo.menuItem.favorite,
      modifierData: sortedModifierData,
      hasLinkedMenuItem: linkedMenuItems.length > 0,
      uniqueIdForLinkedItem
    };
    menuAddToCart(dataToSend, false, false, parentContainsLinkedItem);
    if (linkedMenuItems.length > 0) {
      if (props.match.params.internalId) {
        const itemsToDelete = [];
        cart.forEach((c) => {
          const deleteIndex = linkedMenuItems.findIndex((e) => e.split('|')[0].split('-')[0].includes(c.menuItemId) && c.uniqueIdForLinkedItem === cart[parentMenuItemIndex].uniqueIdForLinkedItem);
          if (deleteIndex === -1 && c.id !== cart[parentMenuItemIndex].id) {
            itemsToDelete.push(c);
          }
        });
        const itemsToAdd = [];
        linkedMenuItems.forEach((c) => {
          const addIndex = cart.findIndex((e) => c.split('|')[0].split('-')[0].includes(e.menuItemId));
          if (addIndex === -1) {
            itemsToAdd.push(c);
          }
        });
        if (itemsToDelete.length > 0) {
          deleteItem(itemsToDelete);
        }
        if (itemsToAdd.length > 0) {
          handleLinkedMenuItemAdd(itemsToAdd, cart, cart[parentMenuItemIndex].uniqueIdForLinkedItem, true);
        }
      } else {
        handleLinkedMenuItemAdd(linkedMenuItems, cart, uniqueIdForLinkedItem, false);
      }
    }
  };

  const onRemoveItemFromCart = () => {
    const itemToDelete = cart.find((e) => e.internalId === Number(props.match.params.internalId));
    deleteItem([itemToDelete], true);
    props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/orders`);
  };

  const modiferPrice = calculateModifierAmount(modifierData);
  const handleCloseButton = () => {
    if (isNestedModifier) {
      toggleNestedModifierFlag(false);
    }
    props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/orders`);
  };

  const outOfStock = itemInfo.menuItem.outOfStock;
  window.addEventListener('scroll', () => {
    const itemName = document.getElementById('itemName');
    if (window.pageYOffset > 0 && (window.innerWidth <= 1023)) {
      if (window.pageYOffset >= 4) {
        if (itemName) {
          itemName.style.position = 'fixed';
          itemName.style.top = '0px';
          itemName.style.zIndex = 998;
          itemName.style.backgroundColor = 'white';
          itemName.style.paddingLeft = window.innerWidth > 1023 ? '40px' : '';
        }
      } else if (window.pageYOffset >= 198) {
        if (itemName) {
          itemName.style.position = 'fixed';
          itemName.style.top = '0px';
          itemName.style.zIndex = 998;
          itemName.style.backgroundColor = 'white';
        }
      } else if (window.pageYOffset < 198) {
        if (itemName) {
          itemName.style.position = 'relative';
          itemName.style.paddingTop = '0px';
          itemName.style.zIndex = '';
          itemName.style.top = '0px';
          itemName.style.backgroundColor = '';
        }
      }
    } else if (window.pageYOffset <= 0 && (window.innerWidth <= 1023)) {
      if (itemName) {
        const positionRelative = window.innerWidth > 1023 ? '' : 'relative';
        itemName.style.position = positionRelative;
        itemName.style.paddingTop = '0px';
        itemName.style.zIndex = '';
        itemName.style.top = '0px';
        itemName.style.backgroundColor = '';
        itemName.style.paddingLeft = window.innerWidth > 1023 ? '0px' : '';
      }
    }
  });

  const FormattedDate = (data) => {
    const getDate = new Date(data);
    const dd = String(getDate.getDate()).padStart(2, '0');
    const mm = String(getDate.getMonth() + 1).padStart(2, '0'); // January is 0!
    return `${mm}/${dd}`;
  };

  const showAvailableDate = (data) => {
    const orderStartDate = data && data.orderStartDate ? FormattedDate(data.orderStartDate) : null;
    const orderEndDate = data && data.orderEndDate ? FormattedDate(data.orderEndDate) : null;
    let availableMsg = '';
    if (orderStartDate && orderEndDate) {
      availableMsg = `Available ${orderStartDate} to ${orderEndDate}`;
    } else if (orderStartDate) {
      availableMsg = `Available from ${orderStartDate}`;
    } else if (orderEndDate) {
      availableMsg = `Available through ${orderEndDate}`;
    }
    return availableMsg;
  };

  const showPreTime = (data) => {
    const preparationTimeUnit = data && data.prepTimeUnit ? data.prepTimeUnit : null;
    const preparationTime = data && data.prepTime ? data.prepTime : null;
    let preparationTimeMsg = '';
    if (preparationTimeUnit === 1) {
      preparationTimeMsg = `Must be ordered ${preparationTime} minutes in advance`;
    } else if (preparationTimeUnit === 2) {
      preparationTimeMsg = `Must be ordered ${preparationTime} hours in advance`;
    } else if (preparationTimeUnit === 3) {
      preparationTimeMsg = `Must be ordered ${preparationTime} days in advance`;
    }
    return preparationTimeMsg;
  };

  const maxOrderQuantity = itemInfo && itemInfo.menuItem && itemInfo.menuItem.maxOrderQuantity > 0 ? itemInfo.menuItem.maxOrderQuantity : null;
  const minOrderQuantity = itemInfo && itemInfo.menuItem && itemInfo.menuItem.minOrderQuantity > 0 ? itemInfo.menuItem.minOrderQuantity : null;
  const prepTimeUnit = menusHashTable[Number(props.match.params.menuTypeId)].prepTimeUnit;
  const prepTime = menusHashTable[Number(props.match.params.menuTypeId)].prepTime;

  const handleClick = () => {
    if (cartQuantity !== 1) {
      addCart(cartQuantity - 1);
    } else if (props.match.params.internalId) {
      setRemoveCartModel(true);
    }
  };

  const handleOnAddCart = () => {
    const sortedModifierData = _.sortBy(modifierData, (o) => {
      return getObjectValue(() => _.find(menuItemsHashTable[Number(props.match.params.menuItemId)].modifierGroupLinks, (d) => d.modifierGroupId === Number(o.split('|')[0].split('-')[1])).sortOrder, 200);
    });
    const requiredModifierList = [];
    menuItemsHashTable[props.match.params.menuItemId].modifierGroupLinks.forEach((item) => {
      if (modifierGroupsHashTable[item.modifierGroupId].minimum > 0 && (modifierGroupsHashTable[item.modifierGroupId].hiddenMenuId !== activeMenuItemId)) {
        requiredModifierList.push({
          ...item,
          modifierGroupId: item.modifierGroupId,
          name: modifierGroupsHashTable[item.modifierGroupId].name,
          minimum: modifierGroupsHashTable[item.modifierGroupId].minimum,
          maximum: modifierGroupsHashTable[item.modifierGroupId].maximum
        });
      }
    });
    const modifierListGroupById = _.groupBy(sortedModifierData, (d) => !d.includes('|') && d.split('|')[0].split('-')[1]);
    const modifierDivs = document.querySelectorAll('[modifier-group]');
    for (let i = 0; i < requiredModifierList.length; i += 1) {
      const weights = getModifierWeight(modifierListGroupById[requiredModifierList[i].modifierGroupId]);
      if (weights < requiredModifierList[i].minimum || (requiredModifierList[i].maximum > 0 && weights > requiredModifierList[i].maximum)) {
        modifierDivs.forEach((modifier) => (Number(modifier.id) === Number(requiredModifierList[i].modifierGroupId)) && modifier.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        }));
        setErrorMessage(`${weights < requiredModifierList[i].minimum ? ERROR_MESSAGE.SELECT_REQUIRED_MODIFIERS : ERROR_MESSAGE.SELECT_EXCEEDS_MODIFIERS}: ${requiredModifierList[i].name} `);
        setIsModifierError(true);
        return;
      }
    }
    handleonAddToCart(cartQuantity);
  };

  const handleAddToCart = () => {
    handleOnAddCart();
  };

  const handleScroll = (ref) => {
    const nestedModifier = document.getElementById(ref);
    if (nestedModifier) {
      nestedModifier.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  const getLinkItem = (item) => {
    Object.values(menuCard).forEach((e) => Object.values(e).find((f) => { if (f.menuItemId === item) return f.price; return 0; }));
    let data = {};
    for (let i = 0; i < Object.values(menuCard).length; i += 1) {
      if (Object.values(menuCard)[i][item]) {
        data = getObjectValue(() => Object.values(menuCard)[i][item], {});
      }
    }
    return data;
  };

  const pushToChildItemToOrder = (childMenuId) => {
    if (menuItemsHashTable[childMenuId].modifierGroupLinks.length > 0) {
      setLinkedItemClicked(true);
    } else {
      setLinkedItemClicked(false);
    }
    setDisable(getObjectValue(() => getLinkItem(childMenuId).menuItem.badge === 6, false) || getObjectValue(() => getLinkItem(childMenuId).menuItem.badge === 1, false));
    props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${props.match.params.menuTypeId}/${childMenuId}?menuId=${urlSearchParams('menuId')}&parentMenuItemId=${urlSearchParams('parentMenuItemId')}`);
  };

  const getBadgeName = (menuItem) => {
    let badgeName = '';
    if (menuItem.outOfStock === true) {
      badgeName = LABEL().OUT_OF_STOCK;
    } else if (menuItem.badge === 1) {
      badgeName = LABEL().VIEW_ONLY;
    } else if (menuItem.badge === 2) {
      badgeName = LABEL().NEW_ITEM;
    } else if (menuItem.badge === 3) {
      badgeName = LABEL().LIMITED_TIME;
    } else if (menuItem.badge === 4) {
      badgeName = LABEL().FEATURED;
    } else if (menuItem.badge === 5) {
      badgeName = LABEL().SPECIAL;
    } else if (menuItem.badge === 6) {
      badgeName = LABEL().COMING_SOON;
    } else if (menuItem.badge === 7) {
      badgeName = LABEL().LIMITED_QUANTITY;
    } else if (menuItem.badge === 8) {
      badgeName = LABEL().ADDITIONAL_TIME;
    } else if (menuItem.badge === 9) {
      badgeName = LABEL().TIME_RESTRICTED;
    } else {
      badgeName = '';
    }
    return badgeName;
  };

  const ParentMenuItemLinks = ({ menuItemInfo }) => {
    return (
      <div className={cn('row w-100 overflowY p-0 mx-0 my-2', isLinkedItemClicked ? 'h25vh' : 'h-100')}>
        {menuItemInfo.menuItem && menuItemInfo.menuItem.links && menuItemInfo.menuItem.links.length > 0 && menuItemInfo.menuItem.links.map((item) => (
          <div className="col-6 my-1 position-relative fs-20" role="presentation" onClick={() => { pushToChildItemToOrder(item.linkedMenuItemId); }} key={item.linkedMenuItemId}>
            {getLinkItem(item.linkedMenuItemId) && getBadgeName(getLinkItem(item.linkedMenuItemId).menuItem) && (
            <span className={cn(styles.removeOutStock, 'position-absolute fs-12')}>{getBadgeName(getLinkItem(item.linkedMenuItemId).menuItem)}</span>
            )}
            <div className={cn('h-100 col-12 d-flex', item.linkedMenuItemId !== itemInfo.menuItemId ? cn('od-modifier-border od-unselected-modifier-bg od-unselected-modifier-font-color', styles.selectedModifier) : cn(styles.activeModifier, 'color-white', 'od-selected-modifier-bg', 'od-selected-modifier-font-color'), window.innerWidth > 1023 ? 'position-sticky' : 'position-relative', 'p-2 rounded')} style={{ minHeight: '9vw' }}>
              <div className="col-8 py-2 fw-600">
                {item.name}
              </div>
              <div className="col-4 px-0 py-2 text-right">
                {getLinkItem(item.linkedMenuItemId) && getLinkItem(item.linkedMenuItemId).price > 0 && `${LABEL().CURRENCY_SYMBOL}${getLinkItem(item.linkedMenuItemId).price?.toFixed(2)}`}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const handleModifierNote = (data, id) => {
    const temp = { ...modifierNote };
    temp[id] = {
      id,
      note: data
    };
    setModifierNote(temp);
  };

  const itemDetailsInfo = parentMenuItemInfo || itemInfo;

  const handleNoteSubmit = (data) => {
    setOpenModal(false);
    setNote(data);
    const dataTosend = cart && cart.map((item) => {
      const modifierJson = item.modifierJson && { ...JSON.parse(item.modifierJson), note };
      if (item.id === Number(urlSearchParams('checkItem'))) {
        return {
          ...item,
          note,
          modifierJson: modifierJson && JSON.stringify(modifierJson)
        };
      } return item;
    });
    updateCartAfterNote(dataTosend);
  };

  const renderModifier = (modifiersObj, node) => (
    <div className={cn('pl-2')}>
      {modifiersObj && modifiersObj.map((modifier) => {
        if (modifier.modifiers && modifier.modifiers.length === 1 && getObjectValue(() => !modifier.modifiers[0].modifierGroupId, false)) {
          return (
            <div key={modifier.id} className="fs-14 fw-500">
              {modifier.modifiers[0].quantity > 1 && (<span className={cn('badge badge-warning ml-1 va-tt', node === 0 ? 'float-right' : '')}>{modifier.modifiers[0].quantity} &times;</span>)}
              {modifier.modifierName}
              {modifier.quantity > 1 && (<span className="badge badge-warning ml-1 va-tt">&times; {modifier.quantity}</span>)}
              {modifier.price && node === 0 ? (<small className="text-muted od-text-muted ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            </div>
          );
        }
        return (
          <div key={modifier.id} className="fs-14 fw-500">
            {modifier.quantity > 1 && <span className={cn('badge badge-warning ml-1 va-tt', node === 0 ? 'float-right' : '')}>{modifier.quantity} &times;</span>}
            {modifier.modifierName}
            {modifier.price && node === 0 ? (<small className="text-muted od-text-muted ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
            {modifier.modifiers && modifier.modifiers.length > 0 && (
              renderModifier(modifier.modifiers)
            )}
          </div>
        );
      })}
    </div>
  );

  // HTML CSS Code

  return (
    <>
      <div className={cn('col-12 col-md-12 p-0 row mx-0 h-100')}>
        {props.loading && <Loader />}
        <div className={cn('col-12 p-1 float-left h-100 w-100')}>
          <div ref={refDetails} className={cn('h-20 row mx-0')}>
            <OrderItemDetail
              itemInfo={itemDetailsInfo}
              addToCart={handleonAddToCart}
              loading={modifierLoder}
              modiferPrice={modiferPrice}
              isUpdate={props.match.params.internalId}
              onRemoveItemFromCart={onRemoveItemFromCart}
              handleCloseButton={handleCloseButton}
              isRemoveCartModelOpen={isRemoveCartModelOpen}
              setRemoveCartModel={setRemoveCartModel}
              changeMenu={changeMenu}
              info={info}
              isKiosk={isKiosk}
              setInfo={setInfo}
              prepTimeUnit={prepTimeUnit}
              prepTime={prepTime}
              menuTypeId={props.match.params.menuTypeId}
              menusHashTable={menusHashTable}
              maxOrderQuantity={maxOrderQuantity}
              minOrderQuantity={minOrderQuantity}
            />
          </div>
          <div className={cn('col-12 col-md-12 col-lg-12 py-1 px-1 od-app-background-color', !isNestedModifier ? 'h-65' : 'h-80')}>
            <div className={cn('h-100 overflowY od-text-primary text-primary')} style={{ paddingBottom: '' }}>
              <div className={cn('overflowY', isLinkedItemClicked ? 'h-50' : '')}>
                {((itemDetailsInfo && itemDetailsInfo.menuItem.orderStartDate) || (itemDetailsInfo && itemDetailsInfo.menuItem.orderEndDate)) && (
                <div className="col-12 p-0 h-50">
                  <div className={cn('od-disclaimer-background')}>
                    <div className={cn('col-12 p-1 py-1 my-2 justify-content-start align-items-center fs-14 fw-600')}>
                      <span>{showAvailableDate(itemDetailsInfo && itemDetailsInfo.menuItem)}</span>
                    </div>
                  </div>
                </div>
                )}
                {(((prepTimeUnit !== 0) && (prepTime !== 0)) || ((itemDetailsInfo && itemDetailsInfo.menuItem.prepTimeUnit !== 0) && (itemDetailsInfo && itemDetailsInfo.menuItem.prepTime !== 0))) && (
                <div className="col-12 p-0">
                  <div className={cn('od-disclaimer-background', styles.restrictionSection, window.innerWidth > 1023 ? 'pl-0' : '')}>
                    <div className={cn('col-12 p-1 py-1 my-2 justify-content-start align-items-center fs-12 fw-700s')}>
                      {(prepTimeUnit > 0 && prepTime > 0) ? (
                        <span>{showPreTime(menusHashTable[Number(props.match.params.menuTypeId)])}</span>
                      ) : (
                        <span>{showPreTime(itemDetailsInfo && itemDetailsInfo.menuItem)}</span>
                      )}

                    </div>
                  </div>
                </div>
                )}
                {(maxOrderQuantity || minOrderQuantity) && (
                <div className="col-12 p-0">
                  <div className={cn('od-disclaimer-background', styles.restrictionSection, window.innerWidth > 1023 ? 'pl-0' : '')}>
                    <div className={cn('p-1 justify-content-start align-items-center fs-12 fw-700')}>
                      <span>Quantity restrictions:</span>
                      {minOrderQuantity && (
                        <span className={cn('ml-2')}>Min {minOrderQuantity}</span>
                      )}
                      {maxOrderQuantity && (
                        <span className={cn('ml-2')}>Max {maxOrderQuantity}</span>
                      )}
                    </div>
                  </div>
                </div>
                )}
                {parentMenuItemInfo && <ParentMenuItemLinks menuItemInfo={parentMenuItemInfo} />}
              </div>
              <div className={cn('overflowY', parentMenuItemInfo ? 'h-50' : 'h-100')}><Modifiers handleModifierNote={handleModifierNote} match={props.match} history={props.history} itemInfo={itemInfo} auth={auth} handleScroll={handleScroll} isOrderAnother={isOrderAnother} /></div>
            </div>
          </div>
          {!isNestedModifier && (
          <div className="h-15">
            <div className={cn('h-50 col-12 col-lg-12 col-md-12 row mx-0 px-1 justify-content-center align-items-center', /* styles.boxShadow */)}>
              <div className="col-8 d-flex justify-content-end p-0">
                <div className="col-2 d-flex">
                  <button className={cn(styles.btnUpdated, styles.btnRounded, 'btn-secondary od-dec-font-btn-color od-dec-counter-btn-color')} type="button" onClick={() => handleClick()} disabled={outOfStock ? 'true' : ''} aria-label="minusCartQtyBtn">
                    <i className="fas fa-minus justify-content-center align-items-center" />
                  </button>
                </div>
                <div className={cn('col-2 justify-content-center d-flex mx-0 align-items-center fw-700 fs-24 od-text-primary text-primary')}>
                  {cartQuantity}
                </div>
                <div className="col-2 d-flex">
                  <button className={cn(styles.btnUpdated, styles.btnRounded, 'btn-secondary od-inc-counter-btn-color od-inc-font-btn-color')} type="button" onClick={() => { addCart(cartQuantity + 1); }} disabled={outOfStock ? 'true' : ''} aria-label="plusCartQtyBtn">
                    <i className="fas fa-plus justify-content-center align-items-center" />
                  </button>
                </div>
              </div>
              <div className={cn('col-4 d-flex justify-content-end', getObjectValue(() => itemDetailsInfo.menuItem.noteEnabled, false) ? '' : 'invisible')}>
                <button type="button" className={cn('btn btn100 btn-primary btn-ripple od-btn-primary rounded shadow-none w-100 fs-14', note && note.length > 0 ? 'od-text-primary' : '')} onClick={() => setOpenModal(true)}>
                  <div className="fs-14">
                    <svg xmlns="http://www.w3.org/2000/svg" width={['kiosk'].includes(flowType()) ? 100 : 30} height={60} fill="currentColor" className={cn('bi bi-card-text')} viewBox="0 0 16 16">
                      <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                      <path d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z" />
                    </svg>
                    {LABEL().ADD_NOTE}
                  </div>
                </button>
              </div>
            </div>
            <div className="col-12 h-50 p-0 d-flex justify-content-center align-items-end">
              <div className="col-6">
                <button type="button" className={cn('btn btn100 btn-primary btn-ripple od-btn-primary rounded shadow-none w-100 fs-14')} onClick={handleCloseButton}>
                  <div className="fs-26">{LABEL().RETURN_TO_MENU}</div>
                </button>
              </div>
              <div className="col-6">
                <button type="button" className={cn('btn btn100 btn-primary btn-ripple od-btn-primary rounded shadow-none w-100 fs-14', (outOfStock || (urlSearchParams('parentMenuItemId') === props.match.params.menuItemId)) ? styles.opacity5 : '')} onClick={handleAddToCart} disabled={(outOfStock || disable || (urlSearchParams('parentMenuItemId') === props.match.params.menuItemId)) ? 'true' : props.loading}>
                  <div className="fs-26">{`${props.match.params.internalId ? LABEL().UPDATE_CART : LABEL().ADD_TO_ORDER}`}</div>
                </button>
              </div>
            </div>
          </div>
          )}
        </div>
        {!isKiosk && (
        <div className={cn('col-12 col-md-3 col-lg-3 px-1 py-1 h-100')}>
          <div className="col-12 h-100 p-1 border border-color-secondary od-container-card-background background-secondary rounded">
            {selectedModifiers ? (
              <div className={cn('px-2 od-text-primary row mx-0 h-100 fs-12')} role="presentation">
                <div className="col-12 p-1 h-10 row mx-0">
                  <div className="text-left fw-500 col-10 p-0">{selectedModifiers.menuItemName}</div>
                  <div className={cn('text-right fw-500 col-2 p-0')}>{selectedModifiers.seats && selectedModifiers.seats.length > 0 && selectedModifiers.seats[0].splitValue > 1 ? `${selectedModifiers.quantity}/${selectedModifiers.seats[0].splitValue}` : selectedModifiers.quantity}</div>
                </div>
                <div className="col-12 p-0 h-90 overflowY">
                  {(selectedModifiers.modifierObject && selectedModifiers.modifierObject.length > 0) && (
                    <div className="col-12 p-0 row mx-0">
                      {selectedModifiers.modifierObject && renderModifier(selectedModifiers.modifierObject, selectedModifiers.note)}
                    </div>
                  )}
                  {note && <div className="col-12 p-0 h-5">{note}</div>}
                </div>
              </div>
            ) : <div className="col-12 p-0 row h-100 text-primary od-text-primary">No Modifiers Selected</div>}
          </div>
        </div>
        )}
      </div>
      <Modal
        isOpen={openModal}
        loading={props.loading}
        customClass2={styles.maxWidth}
      >
        <div className="col-12 p-4 justify-content-center align-items-center position-relative text-center">
          <div
            className="p-1 fs-18 od-app-background-color background-primary text-right"
          >
            <div className="" role="presentation" onClick={() => { setOpenModal(false); }}>
              <i className="fa fa-times" aria-hidden="true" />
            </div>
          </div>
          <SpecialInstruction
            name="specialInstruction"
            type="text"
            isOpen={openModal}
            cancelModal={setOpenModal}
            specialValue={note}
            customClass=""
            specialInstruction
            className="p-2 w-100"
            placeholder={LABEL().TYPE_YOUR_NOTE}
            maxLength={20}
            onSubmit={(e) => handleNoteSubmit(e)}
          />
        </div>
      </Modal>
      {isModifierError && (
      <Modal
        isOpen={isModifierError}
        isModalCenter
        loading={props.loading}
        customClass2={styles.maxWidth}
      >
        <div className="p-2 justify-content-center align-items-center text-center">
          <div className="col-12 fs-18 fw-600 text-center px-0 py-2">
            {errorMessage}
          </div>
          <div className="col-12 row mx-0 px-0 py-2 justify-content-center align-items-center">
            <button className="w-100 btn btn100 btn-primary btn-ripple od-btn-primary fs-14" type="button" onClick={() => { setIsModifierError(!isModifierError); }}>
              <div className="fs-30">{LABEL().KIOSK_OK}</div>
            </button>
          </div>
        </div>
      </Modal>
      )}
    </>
  );
};

// Redux Part

const mapStateToProps = ({
  orders, oauth, keyboard
}) => ({
  loading: orders.loading,
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  seat: orders.seats,
  position: orders.position,
  auth: oauth.authInfo,
  modifierLoder: orders.modifierLoder,
  menuCard: orders.menuCardList,
  menusHashTable: orders.menusHashTable,
  menuItemsHashTable: orders.menuItemsHashTable,
  modifierGroupsHashTable: orders.modifierGroupsHashTable,
  modifierData: orders.modifierData,
  modifiersHashTable: orders.modifiersHashTable,
  isNestedModifier: orders.isNestedModifier,
  cart: orders.cart,
  keyboardInputValue: keyboard.keyboardInputValue || '',
  menusList: orders.menusList,
  menuIndex: orders.menuIndex,
  activeMenuItemId: Number(urlSearchParams('menuId')) || 0
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  pushModifiersGroupData,
  addToCart,
  pushModifierToItem,
  keyboardInput,
  editCartItem,
  toggleNestedModifierFlag,
  setNotification,
  removeItemFromCart,
  updateHeaderData,
  changeMenu,
  pushMenuItemsByScreenId,
  orderItems,
  onSearchItem,
  addChecks,
  enableStartOverBtn,
  updateChecksAfterResponse,
  updateCartAfterNote,
  setFunctionModifierId,
  deleteItm
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OrderItem);
